import { useCardStatusStore } from "../stores/cardStatusStore";
import { CardStatus, UserCard } from "../api/types";

interface UseCardDataReturn {
  status: CardStatus | null;
  userCard: UserCard | null;
  isUserCardDelegated: boolean;
  isLoading: boolean;
  error: string | null;
}

export const useCardData = (): UseCardDataReturn => {
  const { status, userCard, isUserCardDelegated, isLoading, error } =
    useCardStatusStore();

  return {
    status,
    userCard,
    isUserCardDelegated,
    isLoading,
    error,
  };
};
